module.exports = __webpack_public_path__ + "assets/img/starter_entry_explain.98899fee.jpg";